import { prepareQueryParams } from '@homeviews/utils'
import { api, API_V2_BASE_URL } from '@homeviews/store'
import type { AreaGuides } from '@homeviews/analytics'

type AreaGuidesQueryParams = {
  // When true, get AreaGuides only for authenticated user's Developments
  portalDevelopments?: boolean
}

// https://redux-toolkit.js.org/rtk-query/usage/code-splitting
export const areasGuidesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAreaGuides: build.query<AreaGuides, AreaGuidesQueryParams>({
      query: (params: AreaGuidesQueryParams) => ({
        url: `${API_V2_BASE_URL}/area-guides${prepareQueryParams(params)}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  // https://redux-toolkit.js.org/rtk-query/api/created-api/hooks#usequery
  useGetAreaGuidesQuery,
} = areasGuidesApi
